export default "__VITE_ASSET__o8wrVNe9__"